import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take, timer } from 'rxjs';

import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-login-status-banner',
  standalone: true,
  imports: [SharedModule],
  template: `
    @if (message()) {
      <app-banner-message
        [message]="message()"
        [status]="status()"
      ></app-banner-message>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginStatusBannerComponent implements OnInit {
  message = signal<string | null>(null);

  status = signal('warning');

  private route = inject(ActivatedRoute);

  private readonly MESSAGES = {
    sessionExpired: "Session expired. We've logged you out of your account.",
    loggedOut: 'You have successfully logged out.',
    passwordChanged: 'Password changed!',
    registration:
      'Your registration was successful! Please log in to continue.',
  };

  ngOnInit(): void {
    const logout = this.route.snapshot.queryParamMap.get('logout');
    const passwordChanged =
      this.route.snapshot.queryParamMap.get('passwordChanged');

    if (logout === 'expired') {
      this.show(this.MESSAGES.sessionExpired, 'warning');
    } else if (logout === 'manual') {
      this.show(this.MESSAGES.loggedOut, 'success');
    } else if (passwordChanged === 'true') {
      this.show(this.MESSAGES.passwordChanged, 'success');
    } else {
      this.route.fragment.pipe(take(1)).subscribe((fragment) => {
        if (fragment?.includes('id_token')) {
          this.show(this.MESSAGES.registration, 'success');
        }
      });
    }
  }

  private show(message: string, status: string): void {
    this.message.set(message);
    this.status.set(status);
    timer(5000)
      .pipe(take(1))
      .subscribe(() => {
        this.message.set(null);
      });
  }
}
